export const profanityReplacements: Record<string, string> = {
  fuck: "heck",
  fucking: "freaking",
  fucked: "messed up",
  fucker: "friend",
  fuckers: "friends",
  shit: "stuff",
  shitty: "poor",
  bullshit: "nonsense",
  ass: "butt",
  asshole: "friend",
  assholes: "friends",
  damn: "darn",
  damned: "darned",
  dammit: "darn it",
  hell: "heck",
  bitch: "friend",
  bitchy: "difficult",
  bitches: "friends",
  bastard: "friend",
  bastards: "friends",
  crap: "stuff",
  crappy: "poor",
  piss: "annoy",
  pissed: "upset",
  pissing: "annoying",
  suck: "stink",
  sucks: "stinks",
  sucked: "was disappointing",
  sucky: "disappointing",
  screw: "mess",
  screwed: "messed up",
  screwing: "messing",
};
